import { Toaster } from "react-hot-toast";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import { DashboardProvider } from "./providers/Dashboard";
import Theme from "./providers/Theme";
import HealthCheck from "./pages/HealthCheck";
import AuditoriaCadastro from "./pages/AuditoriaCadastro";
import AuditoriaSistema from "./pages/AuditoriaSistema";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AuditoriaCadastroById from "./pages/AuditoriaCadastroById";
import AuditoriaUsuarios from "./pages/AuditoriaUsuarios";
import SinterAuditoria from "./pages/SinterAuditoria";
import { environments } from "./environments";

const queryClient = new QueryClient();

const routerBasename =
  environments.subPath && environments.subPath !== "/"
    ? environments.subPath.replace(/\/$/, "")
    : undefined;

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Theme>
        <Toaster position="top-right" />
        <BrowserRouter basename={routerBasename}>
          <Routes>
            <Route path="/health" element={<HealthCheck />} />
            <Route path="/" element={<Login />} />
            <Route
              path="/dashboard/:id"
              element={
                <DashboardProvider>
                  <Dashboard />
                </DashboardProvider>
              }
            />
            <Route path="/auditoria/cadastro" element={<AuditoriaCadastro />} />
            <Route
              path="/auditoria/cadastro/:id"
              element={<AuditoriaCadastroById />}
            />
            <Route path="/auditoria/sistema" element={<AuditoriaSistema />} />
            <Route path="/auditoria/usuarios" element={<AuditoriaUsuarios />} />
            <Route path="/sinter/auditoria" element={<SinterAuditoria />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </Theme>
    </QueryClientProvider>
  );
}

export default App;